export const styles = {
  container: {
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  },
  contentWrapper: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    flex: 1,
    gap: "16px",
  },
  countriesList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "187px",
    overflowY: "auto",
    width: "fit-content",
    paddingRight: "30px",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.2)",
      borderRadius: "3px",
    },
  },
  countryItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  countryName: {
    fontWeight: 600,
    maxWidth: "95%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  flag: {
    width: "20px",
    height: "16px",
  },
  // Loader specific styles
  mapSkeleton: {
    maxWidth: "400px",
    borderRadius: "8px",
  },
  countriesListLoader: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
  },
  countryItemLoader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  flagSkeleton: {
    borderRadius: "2px",
  },
  countrySkeleton: {
    borderRadius: "4px",
  },
} as const;
